import React, { Component } from 'react';

import Navbar from './components/Navigation/Navbar';

import './App.css';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Navbar />
      </React.Fragment>
    )
  }
}

export default App;
